import React, { useState } from 'react';
import { TabMenu } from 'primereact/tabmenu';
import UserManagementPage from './pages/UserManagementPage';
import TaskManagementPage from './pages/TaskManagementPage';
import InstitutionManagementPage from './pages/InstitutionManagementPage';
import { useGetUserQuery } from "../services/usersApi";
import { renderAvatar } from "../utils/avatar";
import './dashboard.css';
import ProfileManagementPage from "./pages/ProfileManagementPage";
import dziennikLogo from '../logo.png';
import pkg from '../../package.json';
import { Chip } from 'primereact/chip';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState({ index: 0 });
  const { data: user, isLoading } = useGetUserQuery();
  let items = [
    { label: 'Dashboard', icon: 'pi pi-list' },
  ];
  if (!isLoading && user?.type === 'admin') {
    items = [...items,
      { label: 'Pracownicy', icon: 'pi pi-fw pi-users' },
      { label: 'Instytucje', icon: 'pi pi-fw pi-building' }
    ];
  }
  items = [...items, { template: <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '200px'}}><img src={dziennikLogo} height="32" style={{ paddingRight: '20px'}}/><Chip label={pkg.version}/></div>, className: 'avatar-tab' }]
  if (!isLoading) {
    items = [...items, { label: renderAvatar(user, 0, 1, false, "large"), className: 'avatar-tab' }]
  }

  

  return (
    <div className="Wrapper">
      <div className="dashboard-tabmenu-fixed">
        <TabMenu className="dashboard-tabmenu" model={items} activeIndex={activeTab.index} onTabChange={(e) => setActiveTab(e)}>
          {/* TabMenu Component */}
        </TabMenu>
      </div>
      <div className="dashboard-tabmenu-spacer" aria-hidden="true" />
      <div className="dashboard-content">
        {activeTab.index === 0 &&
          <TaskManagementPage />
        }

        {!isLoading && user?.type === "admin" && activeTab.index === 1 && (
          <UserManagementPage />
        )}
        {!isLoading && user?.type === "admin" && activeTab.index === 2 && (
          <InstitutionManagementPage />
        )}
        {!isLoading && user?.type === "admin" && activeTab.index === 4 && (
          <ProfileManagementPage />
        )}
        {!isLoading && user?.type !== "admin" && activeTab.index === 2 && (
          <ProfileManagementPage />
        )}
      </div>
    </div>
  );
};

export default Dashboard;